import { Card, CardBody, Col } from "reactstrap";
import DashboardCommonHeader from "../../../../CommonComponents/DashboardCommonHeader/DashboardCommonHeader";
import { RecentCustomersTitle } from "../../../../../Constants/Constants";
import { H5, Image, LI, P, UL } from "../../../../../AbstractElements";
import { dynamicImage } from "../../../../../Utils";
import { Link } from "react-router-dom";
import { RecentCustomersData } from "../../../../../Data/General/Dashboard/ECommerce";

const RecentCustomers = () => {
  return (
    <Col xl="4" md="6">
      <Card>
        <DashboardCommonHeader title={RecentCustomersTitle} dropdownClass="dropdown-toggle" />
        <CardBody>
          <UL className="recent-customers">
            {RecentCustomersData.map((item, index) => (
              <LI className="d-flex align-items-center gap-2" key={index}>
                <div className="flex-shrink-0">
                  <Image src={dynamicImage(item.image)} alt="" />
                </div>
                <div className="flex-grow-1">
                  <Link to={`${process.env.PUBLIC_URL}/applications/ecommerce/cart`}>
                    <H5>{item.title}</H5>
                  </Link>
                  <P className="text-truncate">
                    {item.id}
                    <span className={`text-${item.color}`}>{item.text}</span>
                  </P>
                </div>
                <div className="recent-text">
                  <H5>{item.price}</H5>
                  <P>{item.time}</P>
                </div>
              </LI>
            ))}
          </UL>
        </CardBody>
      </Card>
    </Col>
  );
};

export default RecentCustomers;
